import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import { emitTrack, regType } from './register-track';
import util from '@/common/util';
import { openLoginHideOtherPop } from '@/components/sign-log';
import checkbox from '@/components/checkbox'
import disclamerRegister from '../../mixins/disclaimer-register';
export default {
    mixins: [disclamerRegister],
    components: { checkbox },
    data: function() {
        return {
            regType
        };
    },
    created() {
        this.onTrackInput = util.debounce(this.onTrackInput, 2000).bind(this);
        this.onTrackEmail = util.debounce(this.onTrackEmail, 2000).bind(this);
        this.onTrackPhone = util.debounce(this.onTrackPhone, 2000).bind(this);
        this.onTrackName = util.debounce(this.onTrackName, 2000).bind(this);
    },
    props: {
        options: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        onTrackInput(type, state) {
            emitTrack(regType[type], state);
        },
        onTrackEmail(type, state) {
            emitTrack(regType[type], state);
        },
        onTrackPhone(type, state) {
            emitTrack(regType[type], state);
        },
        onTrackName(type, state) {
            emitTrack(regType[type], state);
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop(this.options, value);
                }, 1000);
            }
        }
    },
    computed: {
        ...mapState(usePageStore, ['page']),
    }
};
